import { render, staticRenderFns } from "./login-password-type.vue?vue&type=template&id=4a511d34&scoped=true";
import script from "./login-password-type.vue?vue&type=script&lang=js";
export * from "./login-password-type.vue?vue&type=script&lang=js";
import style0 from "./login-password-type.vue?vue&type=style&index=0&id=4a511d34&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4a511d34", null);
export default component.exports;